import RealtimeDatabaseModel from '../base/RealtimeDatabaseModel';

export default class DriverGeoFireActive extends RealtimeDatabaseModel {
  static path = 'drivers-geo-fire-active';
}
